import { Header, Table } from '@tanstack/react-table'

/**
 * Finds the parent header of the current header in the table.
 */
export const findParentHeader = (
    currentHeader: Header<unknown, unknown>,
    table: Table<unknown>
): Header<unknown, unknown> | null => {
    // Iterate through all header groups to search for the parent header
    for (const group of table.getHeaderGroups()) {
        const parentHeader = findParentHeaderRecursive(
            currentHeader,
            group.headers
        )
        if (parentHeader) {
            return parentHeader
        }
    }

    return null // Return null if no parent found
}

/**
 * Recursively searches for the parent header of the current header in a list of headers.
 */
const findParentHeaderRecursive = (
    currentHeader: Header<unknown, unknown>,
    headers: Header<unknown, unknown>[]
): Header<unknown, unknown> | null => {
    for (const header of headers) {
        // Check if the current header is a direct subheader of this header
        if (header.subHeaders.includes(currentHeader)) {
            return header
        }

        // If not found, check recursively in subheaders
        const parentInSubHeaders = findParentHeaderRecursive(
            currentHeader,
            header.subHeaders
        )
        if (parentInSubHeaders) {
            return parentInSubHeaders
        }
    }

    return null // Return null if no parent found
}
